/* ==============================
   Utilities & Accessibility
   ============================== */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video =>
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
  );
  document.querySelectorAll('.js-vimeo').forEach(video =>
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  );
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (![container, first, last].includes(event.target)) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = event => {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetails = event.target.closest('details[open]');
  if (!openDetails) return;
  const summary = openDetails.querySelector('summary');
  openDetails.removeAttribute('open');
  summary.setAttribute('aria-expanded', false);
  summary.focus();
}

/* ==============================
   Summary & Details Accessibility
   ============================== */
document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.id) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (!summary.closest('header-drawer')) {
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
});

/* ==============================
   Quantity Input
   ============================== */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const prevValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (prevValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

/* ==============================
   Shopify Utilities
   ============================== */
if (typeof window.Shopify === 'undefined') window.Shopify = {};

Shopify.bind = (fn, scope) => () => fn.apply(scope, arguments);
Shopify.setSelectorByValue = (selector, value) => {
  for (let i = 0; i < selector.options.length; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = (target, eventName, callback) =>
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
Shopify.postLink = (path, options = {}) => {
  const method = options.method || 'post';
  const params = options.parameters || {};
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (let key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = key;
    hiddenField.value = params[key];
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

/* ==============================
   Menu & Header Drawer
   ============================== */
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetails = event.target.closest('details[open]');
    if(!openDetails) return;
    openDetails === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetails);
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentNode;
    const parentMenu = details.closest('.has-submenu');
    const isOpen = details.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const addTrapFocus = () => {
      trapFocus(summary.nextElementSibling, details.querySelector('button'));
      summary.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    };

    if(details === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summary) : this.openMenuDrawer(summary);
      if(window.matchMedia('(max-width: 990px)')) document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    } else {
      setTimeout(() => {
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', true);
        parentMenu && parentMenu.classList.add('submenu-open');
        (!reducedMotion.matches) ? summary.nextElementSibling.addEventListener('transitionend', addTrapFocus) : addTrapFocus();
      }, 100);
    }
  }

  openMenuDrawer(summary) {
    setTimeout(() => this.mainDetailsToggle.classList.add('menu-opening'));
    summary.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summary);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if(event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(d => { d.removeAttribute('open'); d.classList.remove('menu-opening'); });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(sub => sub.classList.remove('submenu-open'));
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  closeSubmenu(details) {
    const parentMenu = details.closest('.submenu-open');
    parentMenu && parentMenu.classList.remove('submenu-open');
    details.classList.remove('menu-opening');
    details.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(details.querySelector('summary'));
    this.closeAnimation(details);
  }

  closeAnimation(details) {
    let start;
    const step = time => {
      if (start === undefined) start = time;
      if(time - start < 400) requestAnimationFrame(step);
      else details.removeAttribute('open');
    };
    requestAnimationFrame(step);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if(this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const details = event.currentTarget.closest('details');
    this.closeSubmenu(details);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() { super(); }
  openMenuDrawer(summary) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    super.openMenuDrawer(summary);
  }
  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}
customElements.define('header-drawer', HeaderDrawer);

/* ==============================
   Modal & Deferred Media
   ============================== */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', () => this.hide(false));
    this.addEventListener('keyup', e => { if(e.code.toUpperCase()==='ESCAPE') this.hide(); });
    if(this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', e => { if(e.pointerType==='mouse' && !e.target.closest('deferred-media, product-model')) this.hide(); });
    } else {
      this.addEventListener('click', e => { if(e.target===this) this.hide(); });
    }
  }
  connectedCallback() { if(!this.moved) { this.moved=true; document.body.appendChild(this); } }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open','');
    if(popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if(!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.dataset.modal);
      if(modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if(!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    pauseAllMedia();
    if(!this.hasAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferred = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if(focus) deferred.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

/* ==============================
   SliderComponent
   ============================== */
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if(!this.slider || !this.nextButton) return;

    this.initPages();
    new ResizeObserver(()=>this.initPages()).observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(el => el.clientWidth>0);
    if(this.sliderItemsToShow.length<2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft)/this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft/this.sliderItemOffset)+1;
    if(this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent=this.currentPage;
      this.pageTotalElement.textContent=this.totalPages;
    }
    if(this.currentPage!=previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged',{
        detail:{currentPage:this.currentPage,currentElement:this.sliderItemsToShow[this.currentPage-1]}
      }));
    }
    if(this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft===0) this.prevButton.setAttribute('disabled','disabled'); else this.prevButton.removeAttribute('disabled');
    if(this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length-1])) this.nextButton.setAttribute('disabled','disabled'); else this.nextButton.removeAttribute('disabled');
  }

  isSlideVisible(el, offset=0){
    const lastVisibleSlide=this.slider.clientWidth+this.slider.scrollLeft-offset;
    return el.offsetLeft+el.clientWidth<=lastVisibleSlide && el.offsetLeft>=this.slider.scrollLeft;
  }

  onButtonClick(event){
    event.preventDefault();
    const step=event.currentTarget.dataset.step||1;
    this.slideScrollPosition=event.currentTarget.name==='next'?this.slider.scrollLeft+(step*this.sliderItemOffset):this.slider.scrollLeft-(step*this.sliderItemOffset);
    this.slider.scrollTo({left:this.slideScrollPosition});
  }

  /* Optimized setSlideVisibility */
  setSlideVisibility() {
    if(this._rafId) cancelAnimationFrame(this._rafId);
    this._rafId = requestAnimationFrame(()=>{
      const scrollLeft=this.slider.scrollLeft;
      const clientWidth=this.slider.clientWidth;
      this.sliderItemsToShow.forEach((item,index)=>{
        const links=item.querySelectorAll('a');
        const itemLeft=item.offsetLeft;
        const itemRight=itemLeft+item.clientWidth;
        const isVisible=itemRight>scrollLeft && itemLeft<scrollLeft+clientWidth;
        if(isVisible){
          item.setAttribute('aria-hidden','false');
          item.removeAttribute('tabindex');
          links.forEach(link=>link.removeAttribute('tabindex'));
        } else {
          item.setAttribute('aria-hidden','true');
          item.setAttribute('tabindex','-1');
          links.forEach(link=>link.setAttribute('tabindex','-1'));
        }
      });
    });
  }
}
customElements.define('slider-component', SliderComponent);

/* ==============================
   SlideshowComponent
   ============================== */
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    if(!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if(this.sliderItemsToShow.length>0) this.currentPage=1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link=>link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if(this.slider.dataset.autoplay==='true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton=this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed=this.slider.dataset.speed*1000;
    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
    this.autoPlayLoop();
  }

  autoPlayLoop() {
    this.autoPlayTimeout=setTimeout(()=>{
      this.scrollToNextSlide();
      this.autoPlayLoop();
    }, this.autoplaySpeed);
  }

  autoPlayToggle(event){
    event.preventDefault();
    if(this.autoPlayTimeout){
      clearTimeout(this.autoPlayTimeout);
      this.autoPlayTimeout=null;
    } else this.autoPlayLoop();
  }

  focusInHandling(){ if(this.autoPlayTimeout) clearTimeout(this.autoPlayTimeout); }
  focusOutHandling(){ if(!this.autoPlayTimeout) this.autoPlayLoop(); }

  scrollToNextSlide(){
    const nextIndex = this.currentPage < this.sliderItemsToShow.length ? this.currentPage : 0;
    this.slider.scrollTo({left:this.sliderItemsToShow[nextIndex].offsetLeft, behavior:'smooth'});
  }

  linkToSlide(event){
    event.preventDefault();
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);
    if(index<0) return;
    this.slider.scrollTo({left:this.sliderItemsToShow[index].offsetLeft, behavior:'smooth'});
  }
}
customElements.define('slideshow-component', SlideshowComponent);
